module.exports = __webpack_public_path__ + "img/moon-with-clouds-snow.a2361f13.png";